module.exports = __webpack_public_path__ + "img/gold.2ad8a7ac.png";